///
/// Copyright (c) 2017-present, Siklu Ltd.
/// All rights reserved.
///

import { Component, input, model, output, WritableSignal } from '@angular/core';
import { SuiSvgIconComponent } from '@siklu/sui-lib';
import { NgClass } from '@angular/common';
import { ActionIconDirectivesModule } from '../../directives/action-icon-directives/action-icon-directives.module';
import { ButtonsDirectivesModule } from '../../directives/buttons-directives/buttons-directives.module';

export interface WindeSuiTab<T = unknown> {
    title: WritableSignal<string>;
    content?: T;
    closable?: boolean;
    invalid?: boolean;
    hidden?: boolean;
}

@Component({
    selector: 'winde-sui-tabs',
    templateUrl: './sui-tabs.component.html',
    styleUrls: ['./sui-tabs.scss'],
    imports: [NgClass, SuiSvgIconComponent, ActionIconDirectivesModule, ButtonsDirectivesModule]
})
export class SuiTabsComponent<T> {
    tabsList = input<WindeSuiTab<T>[]>();
    activeTab = model<WindeSuiTab<T>>();
    vertical = input<boolean>(true);
    tabClosed = output<WindeSuiTab<T>>();
}
